class DeletePaymentMethodWindow extends React.Component {

    constructor(props) {

        super(props);
        this.state = {
            paymentMethods: [],
            paymentMethodOptions: [],
            paymentMethodLabel: props.paymentMethodLabel,
            selectedMethodId: null,
            replacementMethodId: null,
            associatedRecords: null
        };
    }

    UNSAFE_componentWillUpdate(nextProps, nextState){
        // If Payment Method was changed.
        if(this.state.replacementMethodId !== nextState.replacementMethodId && nextState.paymentMethods) {
            let paymentMethodLabel = this.props.paymentMethodLabel;

            // Find label/display value for Payment Methods and update state for it
            nextState.paymentMethods.forEach(function(item){
                if(item.PaymentProcessorMethod && item.PaymentProcessorMethod.id == nextState.replacementMethodId){
                    paymentMethodLabel = this.getPaymentMethodDisplayValue(item);
                }
            }.bind(this));

            this.setState({
                paymentMethodLabel: paymentMethodLabel
            });
        }
    }

    componentDidMount(){
        if(this.props.visible){
            this.show();
        }
    }

    show(id, associatedRecords, currency) {
        this.setState({
            selectedMethodId: id,
            associatedRecords: associatedRecords,
            currency: currency
        });
        $(this.refs.deletePaymentMethodWindow).modal('show');

        if(this.state.paymentMethods.length > 0){
            // Set last payment method saved to database as replacement method
            this.setState({
                replacementMethodId: this.state.paymentMethods[this.state.paymentMethods.length - 1].PaymentProcessorMethod.id
            });
        }
        this.loadOptions();
    }

    loadOptions(){
        $.ajax({
            url: SS.route('PaymentProcessors', 'PaymentProcessorMethods', 'getAll'),
            data: {
                person_id: this.props.personId,
                site_id: this.props.siteId,
                currency: this.state.currency
            },
            method: 'POST',
            dataType: 'json',
            cache: false,
            success: (function (data) {
                if (data.records.length > 0) {

                    let paymentMethodOptions = [];

                    if(data.records.length > 0){
                        data.records.forEach(function(item){
                            let method = item.PaymentProcessorMethod;

                            if(this.state.selectedMethodId == method.id){
                                return;
                            }

                            paymentMethodOptions.push(
                                <a className="dropdown-item" onClick={this.selectPaymentMethod.bind(this, method.id)} key={method.id}>{this.getPaymentMethodDisplayValue(item)}</a>
                            );
                        }.bind(this));
                    }

                    this.setState({
                        paymentMethods: data.records,
                        paymentMethodOptions: paymentMethodOptions
                    });
                } else if (data.errorInfo) {
                    this.setState({
                        paymentMethods: [],
                        paymentMethodOptions: []
                    });
                    MyPaymentMethodsModule.message('Error', data.errorInfo);
                }
            }).bind(this),
            error: (function (xhr, status, err) {
                MyPaymentMethodsModule.message('Error', 'Unknown error occurred');
            }).bind(this)
        });
    }

    selectPaymentMethod(id){
        this.setState({
            replacementMethodId:id
        })
    }

    addPaymentMethod() {
        var location = this.props.editUrl + '?redirect=' + this.props.hereUrl + '/remove_payment_method_id:' + this.state.selectedMethodId;
        if (this.state.currency) {
            location += '?currency=' + this.state.currency;
        }

        window.location = location += '?currency=' + this.state.currency;
    }

    replaceMethod(event){
        this.deleteRecord({
            id: this.state.selectedMethodId,
            replace: this.state.replacementMethodId
        });
    }

    deactivateAndDeleteMethod(){
        this.deleteRecord({
            id: this.state.selectedMethodId,
            force: 1
        });
    }

    deleteRecord(params){
        let me = this;
        $.ajax({
            url: SS.route('PaymentProcessors','PaymentProcessorMethods','delete'),
            data: params,
            method:'POST',
            cache: false,
            success: function(data) {
                if(data.message.length){
                    MyPaymentMethodsModule.message('Error',($.type(data.message) == 'array' ? data.message.join('<br/>') : data.message));
                }
                if(data.success && me.props.paymentMethodsGrid) {
                    me.props.paymentMethodsGrid.setState({
                        needsLoad: true,
                        loading: true
                    });
                }
            }.bind(this),
            error: function(xhr, status, err) {
                MyPaymentMethodsModule.message('Error', $.type(err) == 'array' ? err.join('<br>') : err);
            }.bind(this),
            complete: function(){
                $(this.refs.deletePaymentMethodWindow).modal('hide');
            }.bind(this)
        });
    }

    getPaymentMethodDisplayValue(paymentMethod){
        let method = paymentMethod.PaymentProcessorMethod;

        // Add custom classes for different payment method (check/card) and cart type (visa, master, etc.)
        let cls = "payment-method method-type-" + method.type;
        if(paymentMethod.PaymentProcessorCard && paymentMethod.PaymentProcessorCard.card_type){
            cls += " card-type " + paymentMethod.PaymentProcessorCard.card_type.toLowerCase().replace(/ /g,"-");
        }

        let hiddenPart = method.check_id?'xxxxxxxxx':'xxxx xxxx xxxx ';

        return (<span className={cls}>
            <span className="hidden-part">{hiddenPart}</span><span className="last-four">{method.last_four}</span>
        </span>);
    }

    render()
    {
        let props = this.props;
        let state = this.state;

        let associatedRecords = null;
        if(state.associatedRecords){
            associatedRecords = [];
            state.associatedRecords.forEach(function(associatedRecord, key){
                let cls = "associated-record record-" + parseInt(key+1);
                if(key+1 == 1){
                    cls += " record-first"
                }
                if(key+1 == state.associatedRecords.length){
                    cls += " record-last"
                }
                associatedRecords.push(
                    <div className={cls} key={key+"-a"}><strong>{associatedRecord}</strong></div>
                );
            });
        }

        let replaceButton = (
            <button type="button" className="btn btn-primary" onClick={this.replaceMethod.bind(this)}>{props.replaceBtnTxt}</button>
        );
        if(!this.state.replacementMethodId){
            replaceButton = (
                <button disabled type="button" className="btn btn-primary disabled">{props.replaceBtnTxt}</button>
            );
        }

        return (
            <div className="modal fade delete-payment-method-window" role="dialog" ref="deletePaymentMethodWindow">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            <h4 className="modal-title">{props.title}</h4>
                        </div>
                        <div className="modal-body center-block text-center">
                            <p className="associated-record-title">This payment method is associated with the following records:</p>
                            <div className="associated-records">{associatedRecords}</div>
                            <p className="divider" />
                            <p className="new-method-title">Please choose a payment method below to replace it with:</p>

                            <div className={"form-group payment-methods add-payment-yes payment-methods-" + (state.paymentMethodOptions.length <= 0?'empty':'available')}>

                                <div className="field-holder field-dropdown">
                                    <div className="btn-group select-payment-method">
                                        <button type="button" className="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            {state.paymentMethodLabel}
                                        </button>
                                        <div className="dropdown-menu">
                                            {state.paymentMethodOptions}
                                        </div>
                                    </div>
                                    <span className="btn-group add-payment-method">
                                        <button className="btn btn-primary" onClick={this.addPaymentMethod.bind(this)}><i className="fa fa-plus" /></button>
                                    </span>
                                    <div className="clearfix"></div>
                                </div>

                                {state.paymentMethodOptions.length <= 0 ? (
                                    <div className="no-payment-methods-message">No Payment Methods Available</div>
                                ) : undefined}

                                <div className="replace-button-holder">
                                    {replaceButton}
                                </div>
                            </div>

                            <div className="or-title">or</div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary btn-block" onClick={this.deactivateAndDeleteMethod.bind(this)}>{props.deactivateBtnTxt}</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

DeletePaymentMethodWindow.propTypes = {
    title: PropTypes.string,
    replaceBtnTxt: PropTypes.string,
    deactivateBtnTxt: PropTypes.string,
    visible: PropTypes.bool,
    siteId: PropTypes.number,
    personId: PropTypes.number,
    editUrl: PropTypes.string,
    hereUrl: PropTypes.string,
    paymentMethodsGrid: PropTypes.any
};

DeletePaymentMethodWindow.defaultProps = {
    title: 'Delete Payment Method',
    replaceBtnTxt: 'Replace',
    deactivateBtnTxt: 'Continue and deactivate the recurring gifts',
    paymentMethodLabel: 'Payment Method',
    visible: false,
    siteId: null,
    personId: null
};